import {
  requestGet,
  requestPost,
  requestPut,
  requestDelete,
} from "../config/Api";

export const getRoles = () => requestGet("/roles");
export const createRole = (data) => requestPost("/roles", data);
export const updateRole = (id, data) => requestPut(`/roles/${id}`, data);
export const deleteRole = (id) => requestDelete(`/roles/${id}`);
export const getPermissions = () => requestGet("/permissions");
